/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, October 5th 2021, 8:14:48 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Avatar, { AvatarProps } from "@mui/material/Avatar";
import { convertTextToInitials } from "lib/utils";

function stringToColor(string: string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.substr(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

function stringAvatar(name: string, props: any) {
  const { splitFirstOnly = true } = props;
  const nameInitials = convertTextToInitials(name);
  try {
    return {
      sx: {
        ...props.sx,
        bgcolor: props.sx?.bgcolor ?? stringToColor(name),
      },
      children: `${nameInitials?.[0]}
      ${splitFirstOnly ? "" : nameInitials?.[1] ?? ""}`,
    };
  } catch {
    return "";
  }
}

interface OSAvatarProps extends AvatarProps {
  name?: any;
  imageSrc?: any;
  splitFirstOnly?: boolean;
}

export const OSAvatar = ({ name, imageSrc = null, children = null, ...otherProps }: OSAvatarProps) => {
  // OTB Africa - fallBackProps is used so that if the passed name is a state variable, the child of the OSAvatar can be
  // rendered as we wait for the stateful name to be set from its initial null state
  const fallBackProps = name ? stringAvatar(name, otherProps) : { children };

  if (imageSrc) return <Avatar alt={name} src={imageSrc} {...otherProps} />;
  return <Avatar {...{ ...otherProps, ...fallBackProps }}></Avatar>;
};
